import axios from 'axios'
import store from '../store/index'
import router from "@/router";
import {UserAgentApplication} from 'msal'

const configAzure = {
    auth: {
        clientId: process.env.VUE_APP_CLIENTE_ID_AZURE,
        authority: 'https://login.microsoftonline.com/ORIGOENERGIA.onmicrosoft.com',
        redirectUri: process.env.VUE_APP_REDIRECT_URI_AZURE,
    },

    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,

    }
}

const loginRequest = {
    scopes: ["User.read"],
    prompt: "select_account"
};
const msal = new UserAgentApplication(configAzure);

function authCallback(error, response) {
    console.log('authCallback', error, response);
    if(error) {
        msal.loginRedirect(loginRequest);
    }
}

msal.handleRedirectCallback(authCallback);

async function obterToken() {
    try {
        const response = await msal.acquireTokenSilent(loginRequest);
        localStorage.setItem('account', JSON.stringify(response.account));
        localStorage.setItem('tokenApi', response.accessToken);

        return 'Bearer ' + response.accessToken;
    } catch (error) {
        try {
            const responseLogin = await msal.loginPopup(loginRequest);
            const response = await msal.acquireTokenSilent(loginRequest);
            localStorage.setItem('account', JSON.stringify(response.account));
            localStorage.setItem('tokenApi', response.accessToken);

            return 'Bearer ' + response.accessToken;
        } catch (error) {
            console.log(error);
        }
    }
}

axios.baseURL = process.env.VUE_APP_URL_API

axios.interceptors.request.use(async request => {

    const token = await obterToken();

    request.baseURL = axios.baseURL;
    request.headers['Authorization'] = token
    request.headers['api-token'] = process.env.VUE_API_TOKEN_BE

    var deveTerLoading = !request.url.split('&').includes('loading=false');

    if (deveTerLoading) {
        store.commit('spinner/toggleSpinner', true)
    }

    return request
})

axios.interceptors.response.use(response => {
    store.commit('spinner/toggleSpinner', false)
    return response;
}, error => {
    store.commit('spinner/toggleSpinner', false)

    console.log('error', error);

    if (error.response.status && ([403, 500, 401].includes(error.response.status))) {
        router.push({name: 'error', query: {error: error.response.status}})
    }

    console.log('error', error);

    return Promise.reject(error)
})

export function logout() {
    msal.logout();
}

export async function obterTokenAzure() {
    return await obterToken();
}

export default axios;



// WEBPACK FOOTER //
// ./src/plugins/axios.js